import { takeEvery } from 'redux-saga/effects';

import * as profileActions from 'store/modules/profile/licence';
import { openVerificationModal } from './utils';

export default function* listenCreateVerificationSession() {
  yield takeEvery(profileActions.verifyLicence.toString(), openVerificationModal);
}
